<section class="bg-[#FEFAF2] pt-[2%] flex">
  <div class="border border-gray-100 w-[80%] h-[450px] relative bg-red-400 mx-auto rounded-[25px]" id="banner">
    <div class="w-fit fosco flex flex-col" id="container1">
      <h1 class="text-white">
        Pare de errar <br> questões de prova!
      </h1>
      <span class="text-white">
        Alunos que resolvem questões tiram notas 72% mais altas.
      </span>

      <button class="text-white bg-red-600 w-fit px-5 py-2 mt-4 rounded-lg" [routerLink]="['/login']">
        Assinar Agora
      </button>
    </div>
  </div>
</section>

<section class="text-gray-600 body-font bg-[#FEFAF2]">
  <div class="container px-5 py-24 mx-auto">
    <h4 class="text-3xl font-bold text-[#001427]">Conheça as vantagens</h4>

    <div class="flex flex-wrap -m-4 pt-10">

      <div class="p-4 w-full md:w-1/2 lg:w-1/4">
        <div class="h-full bg-[#780000] px-6 py-8 rounded-lg text-left relative">
          <div class="mb-4">
            <i class='bx bx-book-open text-5xl text-[#FEFAF2]'></i>
          </div>
          <h6 class="text-white text-xl font-bold leading-tight mb-2">
            Estude <br> O Que Importa
          </h6>
          <p class="leading-relaxed text-white text-sm">
            Nosso banco filtra apenas as questões que mais aparecem nos editais de Agente de Saúde e Agente de Endemias.
          </p>
        </div>
      </div>

      <div class="p-4 w-full md:w-1/2 lg:w-1/4">
        <div class="h-full bg-[#780000] px-6 py-8 rounded-lg text-left relative">
          <div class="mb-4">
            <i class='bx bx-check-double text-5xl text-[#FEFAF2]'></i>
          </div>
          <h6 class="text-white text-xl font-bold leading-tight mb-2">
            Revela Seus <br> Pontos Fracos
          </h6>
          <p class="leading-relaxed text-white text-sm">
            O sistema detecta automaticamente onde você mais erra e mostra estatísticas personalizadas.
          </p>
        </div>
      </div>

      <div class="p-4 w-full md:w-1/2 lg:w-1/4">
        <div class="h-full bg-[#780000] px-6 py-8 rounded-lg text-left relative">
          <div class="mb-4">
            <i class='bx bx-star text-5xl text-[#FEFAF2]'></i>
          </div>
          <h6 class="text-white text-xl font-bold leading-tight mb-2">
            Gabarito<br>Comentado 
          </h6>
          <p class="leading-relaxed text-white text-sm">
            Cada resposta vem com explicação detalhada do professor, mostrando o ‘porquê’ de cada alternativa. Nada de ficar no escuro após errar uma questão!
          </p>
        </div>
      </div>

      <div class="p-4 w-full md:w-1/2 lg:w-1/4">
        <div class="h-full bg-[#780000] px-6 py-8 rounded-lg text-left relative">
          <div class="mb-4">
            <i class='bx bx-line-chart text-5xl text-[#FEFAF2]'></i>
          </div>
          <h6 class="text-white text-xl font-bold leading-tight mb-2">
            Simulados<br>Personalizados
          </h6>
          <p class="leading-relaxed text-white text-sm">
            Você chega no dia da prova já sabendo como a banca pensa, enquanto seus concorrentes ainda estão chutando!
          </p>
        </div>
      </div>

    </div>
  </div>
</section>



<section class="text-gray-600 body-font bg-[#FEFAF2]">
 <div class="container px-5 py-24 mx-auto pt-0">
  <h4 class="text-lg font-semibold mb-6">O que dizem os nossos alunos</h4>
  <div class="flex flex-wrap -m-4">
    <div class="p-4 lg:w-1/4 w-full">
      <div class="h-full bg-[#669BBC] bg-opacity-75 px-3 py-8 rounded-lg overflow-hidden text-center relative">
        <p class="leading-relaxed mb-3 text-white text-[20px]">
          “Fica aqui meu agradecimento, passei no concurso de ACS em segundo lugar. Acertei todas as questões específicas. Gratidão.”
        </p>
        <span class="text-white text-sm">- Selma Martins</span>
      </div>
    </div>
    <div class="p-4 lg:w-1/4 w-full">
      <div class="h-full bg-[#669BBC] bg-opacity-75 px-3 py-8 rounded-lg overflow-hidden text-center relative">
        <p class="leading-relaxed mb-3 text-white text-[20px]">
          “Só passando para agradecer professor, passei em primeiro lugar geral, gratidão!”
        </p>
        <span class="text-white text-sm">- Marcelo Thomaz</span>
      </div>
    </div>
    <div class="p-4 lg:w-1/4 w-full">
      <div class="h-full bg-[#669BBC] bg-opacity-75 px-3 py-8 rounded-lg overflow-hidden text-center relative">
        <p class="leading-relaxed mb-3 text-white text-[20px]">
          “Passei em primeiro lugar da minha USF no concurso para ACS, prefeitura de São José de Piranhas-PB, banca CPCON.”
        </p>
        <span class="text-white text-sm">- Analine Ramos</span>
      </div>
    </div>
  </div>
</div>
</section>

<section class="bg-[#003049] w-full py-10 h-[385px] mt-[30px] relative">
  <div class="container mx-auto flex flex-col md:flex-row items-center justify-center h-full px-5 relative">

    <!-- Bloco da esquerda -->
    <div class="flex flex-row items-start justify-center gap-5 space-y-5 md:w-1/2">

      <div class=" text-white font-bold text-2xl mb-4 fosco2">
        Por apenas<br>R$ 29,90
      </div>
      <div class="">
        <div class="text-white text-sm max-w-xs">
          Acertar mais questões na prova vale o preço de um lanche? 
        </div>

        <button class="bg-[#D62828] hover:bg-[#b31f1f] text-white font-bold py-2 px-6 rounded-full text-sm mt-2" [routerLink]="['/login']">
          Assinar agora
        </button>
      </div>


    </div>

    <!-- Imagem do foguete -->
    <div class="absolute right-[70px] bottom-[-155] w-[300px] md:w-[400px]" style="transform: rotate(24deg);" id="rocket-container">
      <img src="/img/rocket.png" alt="foguete" class="object-contain" id="rocket">
    </div>

  </div>
</section>



<section class="bg-[#fefaf2] py-16 px-4 md:px-12">
  <div class="max-w-[80%] mx-auto flex flex-col md:flex-row items-start gap-8 md:gap-16 items-center">

    <!-- Título -->
    <div class="md:w-1/3">
      <h2 class="text-3xl md:text-4xl font-bold text-[#002e45] leading-tight">
        Perguntas <br /> Frequentes
      </h2>
    </div>

    <!-- Lista de Perguntas -->
    <div class="w-full flex flex-col gap-6 border-l border-[#668199] pl-6">
      <div
        *ngFor="let faq of faqs; let i = index"
        class="border-b border-[#668199] pb-2"
      >
        <div class="flex items-center justify-between">
          <span class="text-[#002e45] font-semibold">{{ faq.pergunta }}</span>
          <button
            class="bg-[#5e97b4] text-white rounded-full p-2"
            (click)="toggleResposta(i)"
          >
            <i
              class="bx"
              [ngClass]="{
                'bx-plus': !faq.visivel,
                'bx-minus': faq.visivel,
                'text-xl': true
              }"
            ></i>
          </button>
        </div>
        <p *ngIf="faq.visivel" class="text-[#002e45] mt-2">
          {{ faq.resposta }}
        </p>
      </div>
    </div>
  </div>
</section>
